import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { InquiriesRoutePath } from '../../core/enums/route-types.enum';
import { NotificationInterface } from '../../core/models/notification.model';
import { ClaimPreviewTabs } from '../../inquiries/claim-preview/claim-preview.component';

@Injectable({
  providedIn: 'root',
})
export class ClaimNotificationOpenerService {
  private router = inject(Router);

  open(notification: NotificationInterface) {
    this.router.navigate(['/', InquiriesRoutePath.ROOT, InquiriesRoutePath.CLAIMS, notification.objectId, ClaimPreviewTabs.COMMUNICATION]);
  }
}
